<template>
  <div>
    <el-descriptions class="margin-top" title="用户信息" :column="3" :size="size" border>
      <template slot="extra">
        <el-button type="warning" size="small" @click="changePassword">修改密码</el-button>
        <el-button type="primary" size="small" @click="editUserInfo">编辑</el-button>
      </template>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          用户名
        </template>
        {{ userInfo.name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          手机号
        </template>
        {{ userInfo.phone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          所在地
        </template>
        {{ userInfo.local}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          身份
        </template>
        <el-tag size="small">{{ userInfo.role }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building"></i>
          联系地址
        </template>
        {{ userInfo.address}}
      </el-descriptions-item>
    </el-descriptions>

    <el-dialog title="编辑用户信息" :visible.sync="dialogFormVisible">
      <el-form :model="editForm">
        <el-form-item label="用户名">
          <!-- 用户名不可修改 -->
          <el-input v-model="editForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="居住地">
          <el-input v-model="editForm.local"></el-input>
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="400px">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
        <el-form-item label="原始密码" prop="oldPassword">
          <el-input type="password" v-model="passwordForm.oldPassword" placeholder="请输入原始密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input type="password" v-model="passwordForm.confirmPassword" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitChangePassword" :loading="passwordLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: {
          name: '',
          phone: '',
          local: '',
          address: '',
          role: ''
        },
        editForm: {
          id: (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}).id,
          name: '',
          phone: '',
          local: '',
          address: ''
        },
        dialogFormVisible: false,
        passwordDialogVisible: false,
        passwordLoading: false,
        passwordForm: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        passwordRules: {
          oldPassword: [
            { required: true, message: '请输入原始密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 5, message: '密码长度不能少于5位', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请确认新密码', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value !== this.passwordForm.newPassword) {
                  callback(new Error('两次输入密码不一致'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      editUserInfo() {
        // 初始化编辑表单，填充当前用户信息
        this.editForm = {
          id: this.userInfo.id || (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).id : null),
          name: this.userInfo.name || '',
          phone: this.userInfo.phone || '',
          local: this.userInfo.local || '',  // 居住地
          address: this.userInfo.address || ''  // 联系地址
        };
        this.dialogFormVisible = true;
      },
      submitEdit() {
        // 准备提交数据
        let submitData = {
          id: this.editForm.id,
          name: this.editForm.name,
          phone: this.editForm.phone,
          local: this.editForm.local,
          address: this.editForm.address
        };

        // 使用统一的保存接口，后端支持 POST /user/ 保存或更新
        this.request.post('/api/user/', submitData).then(res => {
          if (res && res.code === "200") {
            this.$message.success('用户信息更新成功');
            // 更新页面显示并同步 localStorage 中的 user 信息
            this.userInfo = {
              name: this.editForm.name || this.userInfo.name,
              phone: this.editForm.phone || this.userInfo.phone,
              local: this.editForm.local || this.userInfo.local,
              address: this.editForm.address || this.userInfo.address,
              role: this.userInfo.role
            };
            // 更新 localStorage 的 user（保留 token）
            let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
            user.name = this.userInfo.name;
            user.phone = this.userInfo.phone;
            user.local = this.userInfo.local;
            user.address = this.userInfo.address;
            localStorage.setItem('user', JSON.stringify(user));

            this.dialogFormVisible = false;
          } else {
            this.$message.error('用户信息更新失败');
          }
        }).catch(error => {
          console.error(error);
          this.$message.error('用户信息更新失败');
        });
      },
      changePassword() {
        this.passwordForm = {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        };
        this.passwordDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.passwordForm.clearValidate();
        });
      },
      submitChangePassword() {
        this.$refs.passwordForm.validate((valid) => {
          if (valid) {
            this.passwordLoading = true;
            const changePasswordData = {
              userId: this.userInfo.id,
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword
            };

            this.request.post('/api/user/change-password', changePasswordData).then(res => {
              this.passwordLoading = false;
              if (res && res.code === "200") {
                this.$message.success('密码修改成功，请重新登录');
                this.passwordDialogVisible = false;
                // 清除本地存储并跳转到登录页
                localStorage.removeItem('user');
                this.$router.push('/backstagelogin');
              } else {
                this.$message.error(res.message || '密码修改失败');
              }
            }).catch(error => {
              this.passwordLoading = false;
              console.error(error);
              this.$message.error('密码修改失败');
            });
          }
        });
      }
    },
    mounted() {
      // window.location.reload(); 
      const user = localStorage.getItem("user");
      if (user) {
        const userData = JSON.parse(user);
        this.userInfo = {
          id: userData.id,
          name: userData.name || '未设置',
          phone: userData.phone || '未设置',
          local: userData.local || '未设置',
          address: userData.address || '未设置',
          role: userData.role || '未设置'
        };
      }
    },
    created() {
      // 检查 sessionStorage 中的标记
      if (!sessionStorage.getItem('backhomeReloaded')) {
        // 设置标记
        sessionStorage.setItem('backhomeReloaded', 'true');
        // 刷新页面
        location.reload();
      } else {
        // 清除标记，确保下一次导航时可以再次刷新
        sessionStorage.removeItem('backhomeReloaded');
      }
    }
  }    
</script>